module.exports = __webpack_public_path__ + "static/media/elk_clipboard_test_guide.1591f75b.jpg";